export const INVOICE_TYPES = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  REQUESTED: 'Requests',
  COMPLETED: 'Completed'
};
